import { render, staticRenderFns } from "./signForm.vue?vue&type=template&id=aa8d96d0&scoped=true"
import script from "./signForm.vue?vue&type=script&lang=js"
export * from "./signForm.vue?vue&type=script&lang=js"
import style0 from "./signForm.vue?vue&type=style&index=0&id=aa8d96d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa8d96d0",
  null
  
)

export default component.exports